module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUxJREFUSEvtlL1KA0EUhb8DFhYWFhYpLOy0sNBCVFRIwKDW+g4+gQ8hPkh8AEFBRcGIraWCpYWlhYVF4MjAbliTzcwuIV2m3Ln3fPfnzIoJH01YnykgOeH+iGzPAA/AYjIrHvAFtCX9hLB/O7B9ASyMCfgGziT1hgBjCpem13KR7QOgJ+m+ajGVAbaPgcsAAPYlPVeBVAJklV8Bj8AssAYcVoEkAbZ3gBvgFTjKAE9AA9iS9B7rJAqwvQncAR/AXm4920E8WHoeaMYgIwG2l7ORBNu1JAV/94/tJeAl+7A+eJ8HlgIK4r/A9qhk2ytZJ6VFlL6DgfZD5W+xGdsOCw87+QQ28jGWdlBXPBexvQtc50YoQor/omC/sLjV4BZJ3So+L0CawC3QldQa6sD2HNABzuuKFyAnwKmkdnTJdSpPxSYfWkogdT8FpCbEH42Kbxmu7gXtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/PageCommon/img/quickEntryIcon/top1.png
// module id = 0rjK
// module chunks = 89